module.exports = "/_next/static/images/coupe-46ba27395e604d90805a125a7889e9a2.jpg";